// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  fetchOneOrganization,
  organizationsResource,
  selectOneOrganization,
  type Organization,
} from '@gandi/redux-organization';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function useOrganization(sharingId?: ?string): {
  profile: ?Organization,
  isFetchingOrganization: boolean,
  isLoadedOrganization: boolean,
  isFailureOrganization: boolean,
} {
  const dispatch = useDispatch();

  const profile = useAppSelector(state =>
    sharingId ? selectOneOrganization(state, sharingId) : undefined,
  );

  const shouldFetchOrganization = useAppSelector(
    state =>
      !!sharingId &&
      organizationsResource.selectShouldFetchOne(state, sharingId),
  );

  const isFetchingOrganization = useAppSelector(state =>
    sharingId
      ? organizationsResource.selectIsFetchingOne(state, sharingId)
      : false,
  );
  const isLoadedOrganization = useAppSelector(state =>
    sharingId
      ? organizationsResource.selectIsLoadedOne(state, sharingId)
      : false,
  );
  const isFailureOrganization = useAppSelector(state =>
    sharingId
      ? organizationsResource.selectIsFailureOne(state, sharingId)
      : false,
  );

  React.useEffect(() => {
    if (shouldFetchOrganization && sharingId) {
      dispatch(fetchOneOrganization(sharingId));
    }
  }, [dispatch, shouldFetchOrganization, sharingId]);

  return {
    profile,
    isLoadedOrganization,
    isFailureOrganization,
    isFetchingOrganization,
  };
}
